export const EQUOTE_DETAILS_TAB_ID = "eQuote-Details";
export const EQUOTE_COMMENTS_TAB_ID = "eQuote-Comments";